<template>
  <component :is="newTag" :class="classes">
    <slot></slot>
  </component>
</template>

<script lang="ts">
  import Vue from "vue";
  import {EColor} from "~/enums/eColor";
  import {eColors} from "~/modules/gColors/colors";
  import {Logger} from "~/services/logger";

  export default Vue.extend({
    props: {
      tag: {
        type: String,
        default: ''
      },
      mode: {
        type: String,
        default: 'pencil'
      },
      color: {
        type: String as () => EColor,
        default: 'Content'
      },
    },
    data: function() {
      return {
        modality: {
          '': 'em',
          'pen': 'em',
          'pencil': 'em',
          'crayon': 'strong',
          'typewriter': 'strong',
        },
        colors: [...eColors, 'Content', 'Inherit']
      }
    },
    computed: {
      itemColor: {
        get() {
          if(this.colors.includes(this.color)){
            return EColor[this.color];
          }  else if(this.color === "") {
            return "";
          } else {
            Logger.errorOnce('Pen', `Color *${this.color}* not available for the pen.`, 'Try one of these values instead:', this.colors);
            return "color-unavailable";
          }
        },
        set() {},
      },
      newTag() {
        return this.tag === '' ? this.modality[this.mode] : this.tag;
      },
      classes(): object {
        return [
          this.mode,
          this.itemColor,
          ];
      },
    },
  });
</script>
